import { get } from 'lodash/fp';

const useAdminUserChecker = (user) => {
  const userRole = get('title', get('fetchRole', user));
  return userRole === 'Regional Admin' || userRole === 'Super Admin';
};

export default useAdminUserChecker;
